/*
 * Copyright (c) 2020.
 * Ducnq
 */
import isValueEmpty from "./isValueEmpty";

export default function checkImg(url) {
    if (isValueEmpty(url)) {
        return false;
    }

    return(url.match(/\.(jpeg|jpg|png)$/) != null)
}
